// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Iniciar sesión",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.enterEmail": "Introduce tu correo electrónico",
    "auth.enterPassword": "Introduce tu contraseña",
    "auth.loginButton": "Iniciar sesión",
    "auth.loggingIn": "Iniciando sesión...",
    "auth.loginTitle": "Inicio de sesión en el sistema",
    "auth.loginDescription": "Introduce tu correo electrónico y contraseña para acceder",
    "auth.logout": "Cerrar sesión",
    "auth.authError": "Error de autenticación",

    // Common
    "common.loading": "Cargando...",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.create": "Crear",
    "common.close": "Cerrar",
    "common.confirm": "Confirmar",
    "common.yes": "Sí",
    "common.no": "No",
    "common.search": "Buscar",
    "common.filter": "Filtro",
    "common.settings": "Ajustes",
    "common.active": "Activo",
    "common.inactive": "Inactivo",
    "common.blocked": "Bloqueado",
    "common.total": "Total",
    "common.deleteUser": "Eliminar usuario",
    "common.resetPassword": "Restablecer contraseña",
    "common.confirmDelete": "Confirmar eliminación",
    "common.deleteConfirmText": "¿Estás seguro de que quieres eliminar a este usuario? Esta acción no se puede deshacer.",

    // Roles
    "role.admin": "Administrador",
    "role.teacher": "Profesor",
    "role.student": "Estudiante",

    // Navigation
    "nav.dashboard": "Panel de control",
    "nav.users": "Usuarios",
    "nav.students": "Estudiantes",
    "nav.teachers": "Profesores",
    "nav.courses": "Cursos",
    "nav.schedule": "Horario",
    "nav.grades": "Calificaciones",
    "nav.last_entry": "Último acceso",
    "nav.visits": "Visitas",
    "nav.never": "Nunca",

    // Admin Dashboard
    "admin.title": "Panel de administrador",
    "admin.createTeacher": "Crear profesor",
    "admin.systemUsers": "Usuarios del sistema",
    "admin.userManagement": "Gestión de todos los usuarios del sistema",
    "admin.stats.admins": "Admins",
    "admin.stats.teachers": "Profesores",
    "admin.stats.students": "Estudiantes",
    "admin.block": "Bloquear",
    "admin.unblock": "Desbloquear",

    // Teacher Dashboard
    "teacher.title": "Panel del profesor",
    "teacher.inviteStudent": "Invitar estudiante",
    "teacher.myStudents": "Mis estudiantes",
    "teacher.studentManagement": "Gestión de estudiantes en tus grupos",
    "teacher.noStudents": "Aún no tienes estudiantes",
    "teacher.inviteFirst": "Invita a tu primer estudiante haciendo clic en el botón de arriba",
    "teacher.addedOn": "Añadido el:",

    // Student Dashboard
    "student.title": "Panel del estudiante",
    "student.personalInfo": "Información personal",
    "student.yourData": "Tus datos en el sistema",
    "student.fullName": "Nombre completo",
    "student.role": "Rol",
    "student.status": "Estado",
    "student.courses": "Cursos",
    "student.coursesDesc": "Mis cursos y materiales",
    "student.schedule": "Horario",
    "student.scheduleDesc": "Horario de clases",
    "student.grades": "Calificaciones",
    "student.gradesDesc": "Mis calificaciones y logros",
    "student.notifications": "Notificaciones",
    "student.updates": "Últimas actualizaciones y anuncios",
    "student.welcome": "¡Bienvenido al sistema!",
    "student.welcomeDesc":
        "Te has registrado con éxito en el sistema de gestión escolar. Aquí podrás ver tus cursos, horarios y calificaciones.",
    "student.today": "Hoy",
    "student.featuresInDev": "Funciones en desarrollo",
    "student.featuresDesc":
        "Funciones adicionales para estudiantes (cursos, tareas, calificaciones) se añadirán en futuras versiones del sistema.",
    "student.info": "Información",

    // Password Change
    "password.change": "Cambiar contraseña",
    "password.new": "Nueva contraseña",
    "password.confirm": "Confirmar contraseña",
    "password.required": "Es necesario cambiar la contraseña temporal para continuar",
    "password.enter": "Introduce una nueva contraseña para tu cuenta",
    "password.minLength": "Mínimo 6 caracteres",
    "password.repeat": "Repite la nueva contraseña",
    "password.saving": "Guardando...",
    "password.success": "Contraseña cambiada con éxito",
    "password.error": "Error al cambiar la contraseña",
    "password.minError": "La contraseña debe tener al menos 6 caracteres",
    "password.mismatch": "Las contraseñas no coinciden",

    // Create Teacher Modal
    "createTeacher.title": "Crear profesor",
    "createTeacher.description":
        "Introduce los datos del nuevo profesor. Se enviará una invitación al correo electrónico especificado.",
    "createTeacher.fullName": "Nombre completo",
    "createTeacher.fullNamePlaceholder": "Juan Pérez García",
    "createTeacher.emailPlaceholder": "profesor@escuela.es",
    "createTeacher.creating": "Creando...",
    "createTeacher.success": "Profesor creado con éxito",
    "createTeacher.error": "Error al crear el profesor",
    "createTeacher.exists": "Ya existe un usuario con este correo electrónico",

    // Invite Student Modal
    "inviteStudent.title": "Invitar estudiante",
    "inviteStudent.description": "Introduce los datos del nuevo estudiante. Se enviará una invitación al correo electrónico especificado.",
    "inviteStudent.fullName": "Nombre completo",
    "inviteStudent.fullNamePlaceholder": "Pedro Martínez López",
    "inviteStudent.emailPlaceholder": "estudiante@escuela.es",
    "inviteStudent.sending": "Enviando invitación...",
    "inviteStudent.success": "Estudiante invitado con éxito",
    "inviteStudent.error": "Error al invitar al estudiante",

    // System
    "system.title": "Sistema de educación a distancia",
    "system.error": "Error del sistema",
    "system.networkError": "Error de red",
    "system.unauthorized": "Acceso no autorizado",
    "system.forbidden": "Acceso denegado",
    "system.notFound": "No encontrado",
    // Trainers
    "messages.userDeleted": "Usuario eliminado con éxito",
    "messages.passwordReset": "La contraseña ha sido restablecida y enviada al correo electrónico",
    "messages.deleteError": "Error al eliminar el usuario",
    "messages.resetError": "Error al restablecer la contraseña",

    "training.start": "Comenzar entrenamiento",
    "trainings.title": "Módulos de entrenamiento",
    "trainings.memory": "Entrenamiento de memoria",
    "trainings.memory.description": "Ejercicios para entrenar la memoria de los estudiantes",
    "trainings.logic": "Problemas de lógica",
    "trainings.logic.description": "Problemas de lógica y acertijos para estudiantes",
    "trainings.back": "Atrás",
    "trainig.notImplemented": "Este módulo de entrenamiento aún no está implementado",
    // Mental arithmetics
    "trainings.mental": "Aritmética mental",
    "trainings.mental.description": "Entrenamiento de aritmética mental para estudiantes",
    "mentalArithmetic": "Aritmética mental",
    "trainer": "Entrenador",
    "flashCards": "Tarjetas didácticas (Flashcards)",
    "additionSubtraction": "Suma / Resta",
    "multiplicationDivision": "Multiplicación / División",
    "selectTrainerSettings": "Selecciona los ajustes del entrenador",
    "selectCardsSettings": "Selecciona los ajustes de las tarjetas",
    "selectMultiSettings": "Selecciona los ajustes del entrenador",
    "go": "¡Vamos!",
    "theme": "Tema",
    "difficulty": "Dificultad",
    "digits": "Número de dígitos",
    "actionsCount": "Número de acciones",
    "inputTime": "Tiempo para responder",
    "speed": "Velocidad",
    "start": "Inicio",
    "stop": "Parar",
    "settings": "Ajustes",
    "continue": "Continuar",
    "simple": "Simple",
    "brother": "Hermano",
    "friend": "Amigo",
    "friendBrother": "Amigo + Hermano",
    "transitions": "Transiciones",
    "allThemes": "Todos los temas",
    "multiplication": "Multiplicación",
    "division": "División",
    "squaring": "Elevar al cuadrado",
    "performExercise": "Realiza el ejercicio",
    "yourAnswer": "Tu respuesta:",
    "correct": "Correcto",
    "incorrect": "Incorrecto",
    "answer": "Respuesta",
    "sec": "seg",
    "multiplier": "Multiplicador",
    "divisor": "Divisor",
    "any": "Cualquiera",
    "multiplicationTable": "Tabla de multiplicar",
    "byMultiplicationTable": "Por tabla de multiplicar",
    "resetAllSettings": "¿Restablecer todos los ajustes y recargar la página?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Tabla de multiplicar",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "Base 50",
        "base100": "Base 100",
        "base200": "Base 200",
        "byMultiplicationTable": "Por tabla de multiplicar",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "por 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Multiplicación",
        "division": "División",
        "squaring": "Elevar al cuadrado"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}